import React from "react";
import { Globe2 } from "lucide-react";
import { useChains } from "@/lib/chains";

export default function Hero() {
  const chains = useChains();
  const netCount = chains ? chains.length : 70;
  return (
    <section className="pt-4 sm:pt-8 pb-3 sm:pb-6">
      <div className="mb-2.5 sm:mb-4 text-[10.5px] uppercase tracking-[0.28em] text-[var(--accent)] font-semibold">
        Cross-chain DEX aggregator · v1.0
      </div>
      <h1 className="text-[22px] sm:text-[38px] lg:text-[48px] leading-[1.08] font-bold text-[var(--text)] tracking-[-0.03em]">
        <span className="sr-only">Decentralized Exchange — </span>
        The best route between{" "}
        <span className="text-[var(--accent)]">every</span> chain,
        <br className="hidden sm:block" />
        in a single swap.
      </h1>
      <p className="mt-2.5 sm:mt-4 text-[13px] sm:text-[14.5px] text-[var(--text-muted)] leading-relaxed max-w-[560px]">
        A non-custodial DEX that scans 45+ DEXs and 15+ bridges across every EVM chain, plus Solana, Sui, Tron and Bitcoin — in one wallet-native flow.
      </p>
      <div className="mt-4 flex items-center gap-2 text-[11px] text-[var(--text-muted)] font-mono">
        <Globe2 size={12} className="text-[var(--accent)]" />
        <span data-testid="hero-networks-chip"><b className="text-[var(--text)]">{netCount}</b>&nbsp;networks live</span>
      </div>
    </section>
  );
}
